document.addEventListener('DOMContentLoaded', function () {
  var sheet = document.querySelector('[data-kwo-filter-sheet]');
  var backdrop = document.querySelector('[data-kwo-filter-sheet-backdrop]');
  var openBtn = document.querySelector('[data-kwo-filter-sheet-open]');
  var closeBtns = document.querySelectorAll('[data-kwo-filter-sheet-close]');

  if (!sheet || !openBtn) return;

  function openSheet() {
    sheet.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    sheet.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', openSheet);
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeSheet); });
  if (backdrop) backdrop.addEventListener('click', closeSheet);
});
